
import React from 'react';
import { Link } from 'react-router-dom';

export const LoginHeader: React.FC = () => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-4">
        <Link to="/">
          <img 
            src="/lovable-uploads/924a6ca1-11fb-46d9-a66b-f6b94a0c23c6.png" 
            alt="ProptPilot Logo" 
            className="w-48 max-w-full h-auto"
            style={{ objectFit: 'contain' }}
          />
        </Link>
      </div>
      <h1 className="text-3xl font-bold">Welcome back</h1>
      <p className="mt-2 text-muted-foreground">Sign in to manage your properties</p>
    </div>
  );
};
